import React, { useCallback, useState } from 'react';
import { actionTypesOfNonPodiatry } from 'reducer/actionType';
import PageResult from 'components/nonPodiatry/pageResult';
import WhatTreatmentsRecommendedProvider from 'components/nonPodiatry/whatTreatmentsRecommendedProvider';
import HaveYouSeenOtherProviders from 'components/nonPodiatry/haveYouSeenOtherProviders';
import HowLongDidPhysicalTherapy from 'components/nonPodiatry/howLongDidPhysicalTherapy';
import WhatTypeOfPainScreen from 'components/nonPodiatry/whatTypeOfPainScreen';
import WhichSideScreen from 'components/nonPodiatry/whichSideScreen';
import WhatTreatmentsWereHelpful from 'components/nonPodiatry/whatTreatmentsWereHelpful';
import CompletedReasonForVisit from 'components/nonPodiatry/completeNoPodiatry';
import CommonPage from 'components/nonPodiatry/commonPage';
import HowLongExperiencingProblem from 'components/nonPodiatry/howLongExperiencingProblem';
import {
  nonPodiatryOptions,
  haveYouSeenOtherProviderOptions,
} from 'lib/nonPodiatryOptions';
import Header from 'components/common/header';
import useBeforeUnload from 'hooks/useBeforeUnload';

function NoPodiatryApp() {
  const totalPage = 16;
  const [currentPage, setCurrentPage] = useState(1);
  useBeforeUnload(totalPage > currentPage);

  const nextOrSubmitButton = useCallback(
    (nextPage: number, submit?: boolean) => {
      if (submit) {
        if (nextPage === 200) {
          setCurrentPage(nextPage);
          return;
        }
        setCurrentPage(100);

        return;
      }
      setCurrentPage(nextPage);
    },
    [],
  );

  const pageBackButton = (pageNumber: number) => {
    if (pageNumber === 0) {
      return;
    }
    setCurrentPage(pageNumber);
  };

  return (
    <div className="app-page-container">
      <Header
        currentPage={currentPage}
        totalPage={totalPage}
        onClickBackButton={pageBackButton}
      />
      <div className="pt-36 pb-20 px-3">
        {/* Non Podiatry */}
        {currentPage === 1 && (
          <CommonPage
            options={nonPodiatryOptions}
            nextPage={2}
            isFilter
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.REASON_FOR_VISIT}
          />
        )}

        {currentPage === 2 && (
          <WhichSideScreen
            options={nonPodiatryOptions}
            actionPage={actionTypesOfNonPodiatry.WHICH_SIDE}
            nextPage={3}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 3 && (
          <HowLongExperiencingProblem
            nextPage={4}
            nextOrSubmitButton={nextOrSubmitButton}
            isFilter
            currentPage={currentPage + 1}
            options={nonPodiatryOptions}
          />
        )}

        {currentPage === 4 && (
          <CommonPage
            options={nonPodiatryOptions}
            nextPage={5}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.HOW_DID_IT_START}
            multiple={false}
            isFilter
            textFieldForOther
          />
        )}

        {currentPage === 5 && (
          <CommonPage
            options={nonPodiatryOptions}
            nextPage={6}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.WHAT_ARE_YOUR_SYMPTOMS}
            multiple
            isFilter
            textFieldForOther
            required={false}
          />
        )}

        {currentPage === 6 && (
          <WhatTypeOfPainScreen
            options={nonPodiatryOptions}
            nextPage={7}
            currentPage={currentPage}
            isFilter
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.WHAT_TYPE_OF_PAIN}
            multiple
          />
        )}

        {currentPage === 7 && (
          <CommonPage
            options={nonPodiatryOptions}
            nextPage={8}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.PAIN_WORST}
            multiple
            isFilter
            textFieldForOther
          />
        )}
        {currentPage === 8 && (
          <CommonPage
            options={nonPodiatryOptions}
            nextPage={9}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={
              actionTypesOfNonPodiatry.WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER
            }
            multiple
            isFilter
          />
        )}
        {currentPage === 9 && (
          <CommonPage
            options={nonPodiatryOptions}
            nextPage={10}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.TREATMENTS_TRIED_HOME}
            multiple
            isFilter
            textFieldForOther
          />
        )}
        {currentPage === 10 && (
          <HaveYouSeenOtherProviders
            nextPage={11}
            options={haveYouSeenOtherProviderOptions}
            currentPage={currentPage}
            multiple={false}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfNonPodiatry.SEEN_OTHER_PROVIDERS}
          />
        )}

        {currentPage === 11 && (
          <WhatTreatmentsRecommendedProvider
            nextPage={12}
            options={nonPodiatryOptions}
            currentPage={currentPage}
            isFilter
            multiple
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={
              actionTypesOfNonPodiatry.WHAT_TREATMENTS_RECOMMENDED_PRE_PROVIDER
            }
          />
        )}
        {currentPage === 12 && (
          <WhatTreatmentsWereHelpful
            nextPage={13}
            options={nonPodiatryOptions}
            currentPage={currentPage}
            isFilter
            multiple
            actionPage={actionTypesOfNonPodiatry.WHAT_TREATMENTS_WERE_HELPFUL}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 13 && (
          <HowLongDidPhysicalTherapy
            nextPage={14}
            options={nonPodiatryOptions}
            currentPage={currentPage}
            isFilter
            actionPage={actionTypesOfNonPodiatry.HOW_LONG_DID_PHYSICAL_THERAPY}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}

        {/* Page result */}
        {currentPage === 100 && (
          <PageResult nextOrSubmitButton={nextOrSubmitButton} />
        )}

        {currentPage === 200 && <CompletedReasonForVisit />}
      </div>
    </div>
  );
}

export default NoPodiatryApp;
